import _pickBy from "lodash/pickBy";
import _get from "lodash/get";
import "core-js/modules/es6.regexp.constructor.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es6.regexp.split.js";
import { IMAGE_PLACEHOLDERS, PRODUCT_TYPES } from '../constants';
import { getNameWithFallbacks, getImageBySize } from '../utils';
import { isActive } from './common/is-active';

var getCCAnnualFee = function getCCAnnualFee(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.annual_fee.value');
};

var getCCAnnualFeeDetails = function getCCAnnualFeeDetails(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.annual_fee_details.value');
};

var getCCAnnualFeeFirstYear = function getCCAnnualFeeFirstYear(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.annual_fee_first_year.value');
};

var getCCAPRIntroMessageList = function getCCAPRIntroMessageList(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.apr_intro_message_list.value');
};

var getCCBalanceTransferFee = function getCCBalanceTransferFee(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.balance_transfer_fee.value');
};

var getCCBalanceTransferFeeDescription = function getCCBalanceTransferFeeDescription(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.balance_transfer_fee_description.value');
};

var getCCConsBullets = function getCCConsBullets(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.cons_bullets.value');
};

var getCCForeignTransactionFee = function getCCForeignTransactionFee(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.foreign_transaction_fee.value');
};

var getCCForeignTransactionFeeDescription = function getCCForeignTransactionFeeDescription(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.foreign_transaction_fee_description.value');
};

var getCCImageAltText = function getCCImageAltText(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.image_alt_text.value');
};

var getCCIssuerName = function getCCIssuerName(marketplaceEntity) {
  return _get(marketplaceEntity, 'product.institution.name');
};

var getCCLegacyId = function getCCLegacyId(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.legacy_id.value');
};

var getCCMarketingBullets = function getCCMarketingBullets(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.marketing_bullets_without_terms_and_fees_link.value') || _get(marketplaceEntity, 'details.marketing_bullets.value', []);
};

var getCCMaximumAPR = function getCCMaximumAPR(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.apr_max.value');
};

var getCCMaximumFICO = function getCCMaximumFICO(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.max_fico.value');
};

var getCCMinimumAPR = function getCCMinimumAPR(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.apr_min.value');
};

var getCCMinimumDeposit = function getCCMinimumDeposit(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.minimum_deposit.value');
};

var getCCMinimumDepositDescription = function getCCMinimumDepositDescription(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.minimum_deposit_description.value');
};

var getCCMinimumFICO = function getCCMinimumFICO(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.min_fico.value');
};

var getCCOngoingAPR = function getCCOngoingAPR(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.ongoing_apr.value');
};

var getCCPayPerCall = function getCCPayPerCall(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.apply_pay_per_call.value');
};

var getCCPrequalLink = function getCCPrequalLink(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.prequal_link.value');
};

var getCCPrequalLinkText = function getCCPrequalLinkText(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.prequal_link_text.value');
};

var getCCProsBullets = function getCCProsBullets(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.pros_bullets.value');
};

var getCCRating = function getCCRating(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.rating_stars.value');
};

var getCCRewardRateDetails = function getCCRewardRateDetails(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.reward_rate_details.value');
};

var getCCRewardRateNotes = function getCCRewardRateNotes(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.reward_rate_notes.value');
};

var getCCSignUpBonusDetails = function getCCSignUpBonusDetails(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.sign_up_bonus_details.value');
};

var getCCSignUpBonusDetailsAnnotation = function getCCSignUpBonusDetailsAnnotation(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.sign_up_bonus_details_annotation.value');
};

var getCCSlug = function getCCSlug(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.slug.value');
};

var getCCTermsAndFeesLink = function getCCTermsAndFeesLink(marketplaceEntity) {
  return _get(marketplaceEntity, 'derived_details.terms_and_fees_redirect_link.value', _get(marketplaceEntity, 'details.terms_and_fees_link.value'));
};
/**
 * Gets name to display for an offer.
 *
 * @param      {Object}  marketplaceEntity  The CC entity
 *
 * @return     {string}                     The offer name.
 */


export var getName = function getName(marketplaceEntity) {
  return getNameWithFallbacks(marketplaceEntity);
};
/**
 * Gets list of APR intro messages.
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {Array}                      The APR intro message list.
 */

export var getAPRIntroMessageList = getCCAPRIntroMessageList;
/**
 * Gets annual fee.
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {number}                     The annual fee.
 */

export var getAnnualFee = getCCAnnualFee;
/**
 * Gets annual fee details.
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {string}                     The annual fee details.
 */

export var getAnnualFeeDetails = getCCAnnualFeeDetails;
/**
 * Gets annual fee for the first year.
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {number}                     The annual fee for the first year.
 */

export var getAnnualFeeFirstYear = getCCAnnualFeeFirstYear;
/**
 * Gets approval odds.
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {number}                     The approval odds.
 */

export var getApprovalOdds = function getApprovalOdds(marketplaceEntity) {
  return _get(marketplaceEntity, 'derived_details.approval_likelihood.value');
};
/**
 * Gets balance transfer fee.
 *
 * @param      {Object}  marketplaceEntity  The CC entity
 *
 * @return     {number}                     The balance transfer fee (percent).
 */

export var getBalanceTransferFee = getCCBalanceTransferFee;
/**
 * Gets balance transfer fee description.
 *
 * @param      {Object}  marketplaceEntity  The CC entity
 *
 * @return     {string}                     The balance transfer fee description.
 */

export var getBalanceTransferFeeDescription = getCCBalanceTransferFeeDescription;
/**
 * Gets the value of details.compare_categories.
 * @param {Object} marketplaceEntity
 * @returns {string[]} the value of details.compare_categories.
 */

export var getCompareCategories = function getCompareCategories(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.compare_categories.value', []);
};
/**
 * Get the "cons" bullets.
 *
 * @param       {Object} marketplaceEntity  The CC entity
 * @return      {Array}                     The "cons" array
 */

export var getConsBullets = getCCConsBullets;
/**
 * Gets flag to indicate if Apply links are disabled on editorial pages. When this is true, apply
 * links on editorial pages should be hidden or replaced with something else
 *
 * @param  {Object} marketplaceEntity The marketplace entity
 *
 * @return {boolean}                  disabled flag
 */

export var getDisableEditorialApplyLinkFlag = function getDisableEditorialApplyLinkFlag(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.is_editorial_apply_link_disabled.value', false);
};
/**
 * Gets the foreign transaction fee
 *
 * @param     {Object} marketplaceEntity  The CC marketplace entity
 * @return    {number}                    The numeric foreign transaction fee
 */

export var getForeignTransactionFee = getCCForeignTransactionFee;
/**
 * Gets the foreign transaction fee description
 *
 * @param     {Object} marketplaceEntity  The CC marketplace entity
 * @return    {number}                    The numeric foreign transaction fee description
 */

export var getForeignTransactionFeeDescription = getCCForeignTransactionFeeDescription;
/**
 * Gets source URL of the image associated with the offer.
 *
 * @param      {Object}  marketplaceEntity  The CC entity
 * @param      {string}  size               Desired size of image, from constants.IMAGE_SIZES
 *
 * @return     {string}                     The URL of the image.
 */

export var getImageSrc = function getImageSrc(marketplaceEntity) {
  if (!isActive(marketplaceEntity)) {
    return IMAGE_PLACEHOLDERS[PRODUCT_TYPES.CREDIT_CARDS];
  }

  for (var _len = arguments.length, otherArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    otherArgs[_key - 1] = arguments[_key];
  }

  return getImageBySize.apply(void 0, [marketplaceEntity].concat(otherArgs));
};
/**
 * Gets url to learn more page.
 *
 * @param  {Object} marketplaceEntity The marketplace entity
 *
 * @return {String}                   url
 */

export var getLearnMoreLink = function getLearnMoreLink(marketplaceEntity) {
  return "/card-details/card-name/".concat(getSlug(marketplaceEntity));
};
/**
 * Gets the alt text for the image associated with the offer
 *
 * @param  {Object} marketplaceEntity The marketplace entity
 *
 * @return {string}                   Alt text
 */

export var getImageAltText = getCCImageAltText;
/**
 * Get the issuer (to be used with the ApplyNow component).
 *
 * @param {Object} marketplaceEntity The CC entity.
 *
 * @return {string} Issuer name.
 */

export var getIssuerName = getCCIssuerName;
/**
 * Gets legacy numeric id.
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {number}                     The legacy id.
 */

export var getLegacyId = getCCLegacyId;
/**
 * Get the "marketing" bullets.
 *
 * @param       {Object} marketplaceEntity  The CC entity
 * @return      {Array}                     The "marketing" array
 */

export var getMarketingBullets = getCCMarketingBullets;
/**
 * Gets maximum APR
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {number}                     The maximum APR.
 */

export var getMaximumAPR = getCCMaximumAPR;
/**
 * Gets maximum FICO score.
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {number}                     The maximum FICO score.
 */

export var getMaximumFICO = getCCMaximumFICO;
/**
 * Gets minimum APR
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {number}                     The minimum APR.
 */

export var getMinimumAPR = getCCMinimumAPR;
/**
 * Gets minimum deposit.
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {number}                     The minimum deposit.
 */

export var getMinimumDeposit = getCCMinimumDeposit;
/**
 * Gets minimum deposit description.
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {string}                     The minimum deposit description.
 */

export var getMinimumDepositDescription = getCCMinimumDepositDescription;
/**
 * Gets minimum FICO score.
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {number}                     The minimum FICO score.
 */

export var getMinimumFICO = getCCMinimumFICO;
/**
 * Gets ongoing APR.
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {string}                     The ongoing APR.
 */

export var getOngoingAPR = getCCOngoingAPR;
/**
 * Get the apply pay per call telephone number.
 *
 * @param     {Object} marketplaceEntity    The CC entity
 * @return    {string}                      The pay per call telephone number
 */

export var getPayPerCall = getCCPayPerCall;
/**
 * Get the prequal href for an offer if available.
 *
 * @param     {Object} marketplaceEntity    The CC entity
 * @return    {string}                      The prequal href
 */

export var getPrequalLink = getCCPrequalLink;
/**
 * Get the prequal link text for an offer.
 *
 * @param     {Object} marketplaceEntity    The CC entity
 * @return    {string}                      The prequal link text
 */

export var getPrequalLinkText = getCCPrequalLinkText;
/**
 * Get the "pros" bullets.
 *
 * @param       {Object} marketplaceEntity  The CC entity
 * @return      {Array}                     The "pros" array
 */

export var getProsBullets = getCCProsBullets;
/**
 * Gets reward rate details.
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {string}                     The reward rate details.
 */

export var getRewardRateDetails = getCCRewardRateDetails;
/**
 * Gets reward rate notes.
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {string}                     The reward rate notes.
 */

export var getRewardRateNotes = getCCRewardRateNotes;
/**
 * Gets reward type.
 * NOTE: we do not use the cc-util selector for this field since the cc-util selector has a typo
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {string}                     The reward type.
 */

export var getRewardType = function getRewardType(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.reward_type.value');
};
/**
 * Gets reward rate type.
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {string}                     The reward rate type.
 */

export var getRewardRateType = function getRewardRateType(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.reward_rate.type');
};
/**
 * Gets signup bonus.
 * NOTE: we do not use the cc-util selector for this field since the cc-util selector
 * looks at `dervied_details` instead of `details`
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {string}                     The signup bonus.
 */

export var getSignUpBonus = function getSignUpBonus(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.sign_up_bonus.value');
};
/**
 * Gets signup bonus type.
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {string}                     The signup bonus type.
 */

export var getSignUpBonusType = function getSignUpBonusType(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.sign_up_bonus_type.value');
};
/**
 * Gets signup bonus details.
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {string}                     The signup bonus details.
 */

export var getSignUpBonusDetails = getCCSignUpBonusDetails;
/**
 * Gets signup bonus details annotation.
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {string}                     The signup bonus details annotation.
 */

export var getSignUpBonusDetailsAnnotation = getCCSignUpBonusDetailsAnnotation;
/**
 * Gets slug.
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {string}                     The slug.
 */

export var getSlug = getCCSlug;
/**
 * Gets star rating.
 *
 * @param      {Object}  marketplaceEntity  The CC entity.
 * @return     {number}                     The star rating.
 */

export var getStarRating = getCCRating;
/**
 * Gets star rating tooltip.
 *
 * @return     {string}                     The star rating tooltip.
 */

export var getStarRatingTooltip = function getStarRatingTooltip() {
  return "NerdWallet's ratings are determined by our editorial team. The scoring formula takes into account the type of card being reviewed (such as cash back, travel or balance transfer) and the card's rates, fees, rewards and other features.";
};
/**
 * Gets url to terms & fees.
 *
 * @param       {Object} marketplaceEntity  The marketplace entity
 * @return      {String}                    url
 */

export var getTermsAndFeesLink = getCCTermsAndFeesLink;
/**
 * @typedef {Object} ImageDimensions
 * @property {number} height
 * @property {number} width
 */

/**
 * Used to get the image dimensions from an URL. The img URL expected to be one of the
 * following patterns:
 *
 * - https://www.nerdwallet.com/cdn-cgi/image/height=1080,width=1920,quality=85/cdn/images/marketplace/credit_cards/84e1494c-bae2-4b0d-ac8d-e8c095ceb2fe/95f4b4eef72766c5ec9e6535530b866e39a210342ef0541cf276c9b8c0f6f01b.jpg
 * - https://www.nerdwallet.com/cdn-cgi/image/width=1080,quality=85/cdn/images/marketplace/credit_cards/84e1494c-bae2-4b0d-ac8d-e8c095ceb2fe/95f4b4eef72766c5ec9e6535530b866e39a210342ef0541cf276c9b8c0f6f01b.jpg
 * - https://www.nerdwallet.com/cdn-cgi/image/quality=85/cdn/images/marketplace/credit_cards/84e1494c-bae2-4b0d-ac8d-e8c095ceb2fe/95f4b4eef72766c5ec9e6535530b866e39a210342ef0541cf276c9b8c0f6f01b.jpg
 *
 * @see https://nerdwallet.atlassian.net/browse/RUR-501
 * @type {RegExp}
 */

var ImageSrcHeightPattern = new RegExp('height=(.*?)[0-9]*');
var ImageSrcWdithPattern = new RegExp('width=(.*?)[0-9]*');
/**
 * Get Image dimensions.
 *
 * @see getImageBySize
 * @param       {Object} marketplaceEntity  The marketplace entity.
 * @param       {string} [size]             Optional, image size from constants.IMAGE_SIZES.
 * @return      {ImageDimensions}
 */

export var getImageDimensions = function getImageDimensions(marketplaceEntity, size) {
  var _imgSrc$match, _imgSrc$match2;

  var imgSrc = getImageBySize(marketplaceEntity, size);

  if (typeof imgSrc !== 'string') {
    return {};
  }

  return _pickBy({
    height: Number((_imgSrc$match = imgSrc.match(ImageSrcHeightPattern)) === null || _imgSrc$match === void 0 ? void 0 : _imgSrc$match[0].split('=')[1]) || undefined,
    width: Number((_imgSrc$match2 = imgSrc.match(ImageSrcWdithPattern)) === null || _imgSrc$match2 === void 0 ? void 0 : _imgSrc$match2[0].split('=')[1]) || undefined
  }, function (entry) {
    return entry !== undefined;
  });
};
/**
 * Gets bonus cash offer value.
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {number}                     The bonus cash offer value.
 */

export var getBonusCashOfferValue = function getBonusCashOfferValue(marketplaceEntity) {
  return _get(marketplaceEntity, 'derived_details.net_rewards.value');
};
/**
 * Gets bonus cash offer type.
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {string}                     The bonus cash offer type.
 */

export var getBonusCashOfferType = function getBonusCashOfferType(marketplaceEntity) {
  return _get(marketplaceEntity, 'derived_details.net_rewards.type', '');
};
/**
 * Gets Balance transfer intro time value.
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {number}                     The Balance transfer intro time.
 */

export var getBalanceTransferIntroTime = function getBalanceTransferIntroTime(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.balance_transfer_intro_time.value');
};
/**
 * Gets purchase intro time value.
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {number}                     The purchase intro time.
 */

export var getPurchaseIntroTime = function getPurchaseIntroTime(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.purchase_intro_time.value');
};
/**
 * Gets Balance transfer intro apr value.
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {number}                     The Balance transfer intro apr value.
 */

export var getBalanceTransferIntroApr = function getBalanceTransferIntroApr(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.balance_transfer_intro_apr.value');
};
/**
 * Gets reward cents per unit value.
 * @param      {Object}  marketplaceEntity  The CC entity.
 *
 * @return     {number}                     The reward cents per unit value.
 */

export var getRewardCentsPerUnitValue = function getRewardCentsPerUnitValue(marketplaceEntity) {
  return _get(marketplaceEntity, 'derived_details.reward_cents_per_unit.value');
};
/**
 *
 * Get Review Link for offer
 * @param     {Object}  marketplaceEntity   The CC entity
 *
 * @return    {String}                      The URL to the Nerwallet review for the entity
 */
// TODO: this is currently only used in RUR clients. If/when the usage of this becomes global,
// we should uplift this into `getLearnMoreLink`

export var getReviewLink = function getReviewLink(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.review_link.value');
};
/**
 * Gets match score value.
 *
 * @param       {Object} marketplaceEntity  The marketplace entity
 * @return      {number}                    The match score.
 */

export var getMatchScore = function getMatchScore(marketplaceEntity) {
  return _get(marketplaceEntity, 'derived_details.match_score.value', null);
};
/**
 * Get Image raw dimensions.
 *
 * @see getImageBySize
 * @param       {Object} marketplaceEntity  The marketplace entity.
 * @return      {ImageDimensions}
 */

export var getImageRawDimensions = function getImageRawDimensions(marketplaceEntity) {
  return {
    height: _get(marketplaceEntity, 'details.image_raw_height.value', null),
    width: _get(marketplaceEntity, 'details.image_raw_width.value', null)
  };
};